// extracted by mini-css-extract-plugin
export default {"descriptions":"Edlmodal_descriptions__lFtmQ","passwordChangeInput":"Edlmodal_passwordChangeInput__xm3m-"};